import React, { useState } from 'react';
import { Box, Flex, Text, HStack, IconButton, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerBody, VStack, Link, useDisclosure } from '@chakra-ui/react';
import { SearchIcon, ShoppingBagIcon, UserIcon, MenuIcon } from 'lucide-react';
export function Navbar() {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const navLinks = ['Shop', 'New Arrivals', 'Collections', 'About', 'Pop-Ups'];
  return <>
      <Box as="nav" position="sticky" top={0} zIndex={100} bg="white" borderBottom="1px solid" borderColor="rgba(244,184,193,0.4)" boxShadow="0 2px 12px rgba(244,184,193,0.12)" data-id="element-125">
        <Flex align="center" justify="space-between" maxW="1280px" mx="auto" px={{
        base: 4,
        md: 8
      }} h={{
        base: '60px',
        md: '72px'
      }} data-id="element-126">
          {/* Mobile: Hamburger left */}
          <Box display={{
          base: 'flex',
          lg: 'none'
        }} alignItems="center" data-id="element-127">
            <IconButton aria-label="Open menu" icon={<MenuIcon size={22} data-id="element-129" />} variant="ghost" onClick={onOpen} color="gray.700" minW="44px" h="44px" _hover={{
            bg: 'pink.50'
          }} data-id="element-128" />
          </Box>

          {/* Logo */}
          <Box flex={{
          base: 1,
          lg: 'none'
        }} textAlign={{
          base: 'center',
          lg: 'left'
        }} data-id="element-130">
            <Text className="font-script" fontSize={{
            base: '28px',
            md: '34px'
          }} color="#C9929D" lineHeight={1.1} letterSpacing="0.02em" data-id="element-131">
              Love & xx's
            </Text>
          </Box>

          {/* Desktop nav links — center */}
          <HStack spacing={8} display={{
          base: 'none',
          lg: 'flex'
        }} position="absolute" left="50%" transform="translateX(-50%)" data-id="element-132">
            {navLinks.map(link => <Link key={link} href="#" className="font-body" fontSize="14px" fontWeight={500} color="#3A3A3A" letterSpacing="0.04em" textDecoration="none" _hover={{
            color: '#C9929D',
            textDecoration: 'none'
          }} transition="color 0.2s" data-id="element-133">
                {link}
              </Link>)}
          </HStack>

          {/* Right icons */}
          <HStack spacing={1} data-id="element-134">
            <IconButton aria-label="Search" icon={<SearchIcon size={18} data-id="element-136" />} variant="ghost" color="#3A3A3A" minW="44px" h="44px" display={{
            base: 'none',
            md: 'flex'
          }} _hover={{
            color: '#C9929D',
            bg: 'pink.50'
          }} data-id="element-135" />
            <IconButton aria-label="Account" icon={<UserIcon size={18} data-id="element-138" />} variant="ghost" color="#3A3A3A" minW="44px" h="44px" display={{
            base: 'none',
            md: 'flex'
          }} _hover={{
            color: '#C9929D',
            bg: 'pink.50'
          }} data-id="element-137" />
            <IconButton aria-label="Cart" icon={<ShoppingBagIcon size={18} data-id="element-140" />} variant="ghost" color="#3A3A3A" minW="44px" h="44px" _hover={{
            color: '#C9929D',
            bg: 'pink.50'
          }} position="relative" data-id="element-139" />
          </HStack>
        </Flex>
      </Box>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} data-id="element-141">
        <DrawerOverlay data-id="element-142" />
        <DrawerContent maxW="280px" data-id="element-143">
          <DrawerCloseButton color="#C9929D" mt={2} data-id="element-144" />
          <DrawerBody pt={12} pb={8} data-id="element-145">
            <Box mb={8} textAlign="center" data-id="element-146">
              <Text className="font-script" fontSize="32px" color="#C9929D" lineHeight={1.1} data-id="element-147">
                Love & xx's
              </Text>
            </Box>
            <VStack spacing={0} align="stretch" data-id="element-148">
              {navLinks.map(link => <Link key={link} href="#" display="block" py={4} px={2} className="font-body" fontSize="16px" fontWeight={500} color="#3A3A3A" borderBottom="1px solid" borderColor="rgba(244,184,193,0.3)" textDecoration="none" _hover={{
              color: '#C9929D',
              bg: '#FFF5F6',
              textDecoration: 'none'
            }} transition="all 0.2s" data-id="element-149">
                  {link}
                </Link>)}
            </VStack>
            <HStack spacing={4} mt={8} justify="center" data-id="element-150">
              <IconButton aria-label="Search" icon={<SearchIcon size={18} data-id="element-152" />} variant="ghost" color="#3A3A3A" minW="44px" h="44px" _hover={{
              color: '#C9929D'
            }} data-id="element-151" />
              <IconButton aria-label="Account" icon={<UserIcon size={18} data-id="element-154" />} variant="ghost" color="#3A3A3A" minW="44px" h="44px" _hover={{
              color: '#C9929D'
            }} data-id="element-153" />
            </HStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>;
}